import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { tr } from "@/lib/i18n";
import { sfx } from "@/lib/audio";
import { CUSTOMERS, salesmanSprite, bgSrc } from "@/lib/customers";
import { PixelSprite } from "./PixelSprite";

const Shadow = ({ left }) => (
  <div className="absolute bottom-[2.6em] h-[1.4em] w-[10em] rounded-[50%] bg-black/30" style={{ left }} />
);

export const IntroScene = ({ customer, number, shirtColor, lang, onDone }) => {
  const [arrived, setArrived] = useState(false);

  useEffect(() => {
    sfx.chime();
    const a = setTimeout(() => { setArrived(true); sfx.blip(); }, 3300);
    const b = setTimeout(onDone, 6800);
    return () => { clearTimeout(a); clearTimeout(b); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="absolute inset-0" data-testid="host-intro-scene">
      <div className="store-bg" style={bgSrc(customer.background) ? { backgroundImage: `url(${bgSrc(customer.background)})` } : undefined} />
      <div className="vignette" />
      <motion.div
        className="absolute left-0 right-0 top-[3em] flex flex-col items-center"
        initial={{ y: "-12em" }}
        animate={{ y: 0 }}
        transition={{ type: "spring", stiffness: 160, damping: 14, delay: 0.2 }}
      >
        <div className="px-box px-box-dark px-[1.6em] py-[1em]">
          <div data-testid="host-customer-title" className="font-press text-[3.4em] text-[#FFD700]" style={{ textShadow: "0.12em 0.12em 0 #000" }}>
            {tr(lang, "customer_nr", { n: number }).toUpperCase()}
          </div>
        </div>
        <div className="px-box px-box-dark mt-[1.4em] px-[1em] py-[0.4em]">
          <span className="font-pixel font-bold text-[2.2em] text-white" data-testid="host-intro-customer-name">{customer.name}</span>
        </div>
      </motion.div>

      <Shadow left="32.5em" />
      <div className="absolute left-[30em] bottom-[3em]">
        <PixelSprite params={salesmanSprite(shirtColor)} height="30em" testId="host-salesman-sprite" />
      </div>

      <motion.div
        className="absolute bottom-[3em]"
        initial={{ left: "74em", opacity: 0 }}
        animate={{ left: "46em", opacity: 1 }}
        transition={{ left: { duration: 2.6, ease: "easeOut" }, opacity: { duration: 0.4, ease: "easeOut" } }}
      >
        <div className="absolute bottom-[-0.4em] left-[2.5em] h-[1.4em] w-[10em] rounded-[50%] bg-black/30" />
        <PixelSprite params={CUSTOMERS[customer.type].sprite} walking={!arrived} facing="left" height="30em" testId="host-customer-sprite" />
      </motion.div>

      {arrived && (
        <motion.div
          className="absolute left-[27em] bottom-[35em]"
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ type: "spring", stiffness: 500, damping: 20 }}
          style={{ transformOrigin: "30% 100%" }}
        >
          <div className="bubble text-[2.6em]" data-testid="host-speech-bubble">{tr(lang, "how_help")}</div>
        </motion.div>
      )}
    </div>
  );
};
